"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSalgoStartDate = void 0;
const constants_1 = require("../domain/constants");
const time_1 = require("../domain/time");
const getDefaultSalgoStartDate = (businessUnitId, series) => {
    if (businessUnitId === constants_1.BUSINESS_UNITS_WITH_SERIES.OCR.id) {
        if (series.month === time_1.MonthNumber.JANUARY) {
            return `${series.year}-01-05T00:00:00.000Z`;
        }
        else if (series.month === time_1.MonthNumber.JUNE) {
            return `${series.year}-05-01T00:00:00.000Z`;
        }
        else if (series.month === time_1.MonthNumber.NOVEMBER) {
            return `${series.year}-11-01T00:00:00.000Z`;
        }
    }
    else if (businessUnitId === constants_1.BUSINESS_UNITS_WITH_SERIES.CIE.id) {
        if (series.month === time_1.MonthNumber.MARCH) {
            return `${series.year}-02-01T00:00:00.000Z`;
        }
        else if (series.month === time_1.MonthNumber.JUNE) {
            return `${series.year}-04-01T00:00:00.000Z`;
        }
        else if (series.month === time_1.MonthNumber.NOVEMBER) {
            return `${series.year}-10-01T00:00:00.000Z`;
        }
    }
};
exports.getDefaultSalgoStartDate = getDefaultSalgoStartDate;
